import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl } from "../lib/ui.jsx";

export default function Verify() {
  const { act } = useAuth();
  const [u, ur] = useLoad("users", { verified: 0, per: 100 });
  const [c, cr] = useLoad("codes");
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const both = () => { ur(); cr(); };

  return (
    <>
      <h1>Verification</h1>
      <div className="box" style={{ padding: 14, maxWidth: 520, marginTop: 12 }}>
        <label>Unverified user</label>
        <select style={{ width: "100%" }} value={id} onChange={(e) => setId(e.target.value)}>
          <option value="">Choose user</option>
          {u?.rows?.map((x) => <option key={x.SopnoID} value={x.SopnoID}>{x.Name} ({x.Email})</option>)}
        </select>
        <label style={{ display: "block", marginTop: 8 }}>Verification code</label>
        <input style={{ width: "100%" }} maxLength={7} inputMode="numeric" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} />
        <div className="bar">
          <button className="btn" disabled={!id || !code} onClick={async () => { if (await act("verify_code", { sopnoid: id, code }, "User verified.")) { setCode(""); setId(""); both(); } }}>Verify code</button>
          <button className="btn g" disabled={!id} onClick={async () => { const r = await act("resend_code", { sopnoid: id }, "New code created."); if (r?.code) alert("Code: " + r.code); both(); }}>Send new code</button>
          <button className="btn g" disabled={!id} onClick={async () => { if (await act("verify_manual", { sopnoid: id }, "Verified manually.")) both(); }}>Verify manually</button>
        </div>
      </div>
      <h2>Pending codes</h2>
      <Wait d={c}>
        {c && !c.error && (
          <Tbl rows={c.rows} empty="No pending codes." cols={[
            ["User", (r) => r.Name || r.SopnoID], ["Email", (r) => r.Email], ["Type", (r) => r.ver_type],
            ["Code", (r) => <b>{r.code}</b>], ["Created", (r) => r.create_t],
          ]} />
        )}
      </Wait>
    </>
  );
}
